import {useAuthService} from "~/composables/useAuthService";

export default defineNuxtRouteMiddleware(async (to, from) => {
    const {isSuperUser} = useAuthService();
    if (!isSuperUser.value) {
        return navigateTo('/login?authRestricted=true&redirectUrl=' + to.path);
    }
});
